import { render, staticRenderFns } from "./Candle.vue?vue&type=template&id=289aea25&scoped=true"
import script from "./Candle.vue?vue&type=script&lang=js"
export * from "./Candle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "289aea25",
  null
  
)

export default component.exports